<template>
  <div></div>
</template>

<script>
import { service } from '../../main.js'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  mounted() {
    if (Object.keys(this.$route.query).length <= 0) {
      this.$router.push('/' + this.Language)
      return
    }
    if (this.$route.query.t === undefined && this.$route.query.cxd === undefined) {
      this.$router.push('/' + this.Language)
      return
    }

    // $conf['URLs']['lp-partners'] = "/partners";
    const destinationURLs = {
      register: `/${this.Language}/register/live`,
      demo: `/${this.Language}/register/demo`,
      partner: `/${this.Language}/register/partner`,
      bonus: `https://plexytrade.com/promotions/bonus`,
      pamm: `https://plexytrade.com/platforms/pamm/#statistics`,
      home: `https://plexytrade.com`,
    }

    let destination = destinationURLs['register']

    if (this.$route.query.term !== undefined) {
      destination = destinationURLs[this.$route.query.term]
    }

    if (this.$route.query.cxd !== undefined) {
      this.$createCookie('cx_token', this.$route.query.cxd, 14)
    }
    if (this.$route.query.affid !== undefined) {
      this.$createCookie('aff_id', this.$route.query.affid, 14)
    }

    // Carry the IB code in the URL for EVERY destination (register/demo/partner included),
    // not just bonus/home/pamm. URL params survive even when cookies/storage are blocked or
    // cleared (Safari ITP, private mode, content blockers), so the gate keeps working.
    if (this.$route.query.t !== undefined) {
      destination = this.appendQueryParam(destination, 't', this.$route.query.t)

      // Persist redundantly (cookie + localStorage + sessionStorage) as a fallback.
      this.$setReferralCode(this.$route.query.t)

      // ajax store action
      service.get('/ib/add-visit', {
        params: {
          code: this.$route.query.t,
        },
      })
    }

    // redirect regardless
    window.location = destination
  },
  methods: {
    appendQueryParam(url, key, value) {
      // Insert the query param before any hash fragment so URLs like
      // "https://site/path/#section" become "https://site/path/?key=value#section".
      const [base, hash] = url.split('#')
      const separator = base.indexOf('?') === -1 ? '?' : '&'
      const newBase = `${base}${separator}${key}=${encodeURIComponent(value)}`
      return hash !== undefined ? `${newBase}#${hash}` : newBase
    },
  },
}
</script>
